import React, { useEffect, useState } from "react";

// Next Sunday 23:59:59 (local time); resets weekly
const nextSundayEnd = () => {
  const now = new Date();
  const end = new Date(now);
  end.setDate(now.getDate() + ((7 - now.getDay()) % 7));
  end.setHours(23, 59, 59, 999);
  if (end <= now) end.setDate(end.getDate() + 7);
  return end;
};

const pad = (n) => String(n).padStart(2, "0");

export const SaleCountdown = () => {
  const [left, setLeft] = useState(() => nextSundayEnd() - new Date());

  useEffect(() => {
    const t = setInterval(() => setLeft(nextSundayEnd() - new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const s = Math.max(0, Math.floor(left / 1000));
  const parts = [
    { v: Math.floor(s / 86400), l: "D" },
    { v: Math.floor((s % 86400) / 3600), l: "H" },
    { v: Math.floor((s % 3600) / 60), l: "M" },
    { v: s % 60, l: "S" },
  ];

  return (
    <div className="inline-flex flex-col gap-1" data-testid="hero-sale-countdown">
      <p className="text-[8px] sm:text-[10px] tracking-[0.3em] uppercase font-semibold text-plum/60">
        Ends Sunday 11:59 PM
      </p>
      <div className="inline-flex items-center gap-1 sm:gap-1.5">
        {parts.map((p, i) => (
          <React.Fragment key={p.l}>
            <span
              className="inline-flex items-baseline gap-0.5 px-1.5 sm:px-2.5 py-1 sm:py-1.5 rounded-lg backdrop-blur-md"
              style={{
                background: "rgba(255,255,255,0.55)",
                border: "1px solid rgba(197,152,90,0.35)",
                boxShadow: "0 6px 14px -10px rgba(74,44,53,0.4)",
              }}
            >
              <span className="font-serif text-plum text-[13px] sm:text-[20px] leading-none tabular-nums" data-testid={`countdown-${p.l}`}>
                {pad(p.v)}
              </span>
              <span className="text-[7px] sm:text-[9px] font-semibold text-gold">{p.l}</span>
            </span>
            {i < parts.length - 1 && <span className="text-gold/70 text-[10px] sm:text-sm">:</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SaleCountdown;
